module.exports = __webpack_public_path__ + "img/euro-white.17d0b1d3.svg";